/**
 * @file
 * Simple helpers for the ymca_okanagan_lb theme.
 */

(function ($, Drupal, drupalSettings, once) {

  'use strict';

})(jQuery, Drupal, drupalSettings, once);
